import { Tractor, Layers, Mountain, Trees, Box, Database, Globe2, Briefcase } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const ICONS = [Tractor, Layers, Mountain, Trees, Box, Database, Globe2, Briefcase];

export const Applications = () => {
  const { t } = useLang();
  const a = t.applications;

  return (
    <section id="applications" className="bg-background border-b border-border" data-testid="applications">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <Overline index="04">{a.label}</Overline>
              <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-nero-ink leading-[1.05]">
                {a.title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.1}>
              <p className="font-body text-base leading-relaxed text-zinc-600">{a.subtitle}</p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
          {a.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={(i % 4) * 0.06}>
                <div
                  className="group h-full bg-white border-b border-r border-border p-7 min-h-[210px] flex flex-col hover:bg-nero-ink transition-colors duration-300"
                  data-testid={`application-card-${i}`}
                >
                  <div className="flex items-center justify-between">
                    <Icon className="h-7 w-7 text-nero-ink group-hover:text-nero-green transition-colors" strokeWidth={1.5} />
                    <span className="font-heading text-xs font-bold text-zinc-300 group-hover:text-white/30 transition-colors">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div className="mt-auto pt-8">
                    <h3 className="font-heading text-lg font-medium tracking-tight text-nero-ink group-hover:text-white transition-colors">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 font-body text-sm leading-relaxed text-zinc-500 group-hover:text-white/55 transition-colors">
                      {item.text}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
